<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="12">
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t('order.settlementTime')">
              <a-range-picker v-model="queryParam.lendingTime" format="DD-MM-YYYY" style="width: 100%" />
            </a-form-item>
          </a-col>
          <!-- <a-col :md="6" :sm="8">
            <a-form-item :label="$t(I18N_KEY.REBORROWCOUNT + 'productType')">
              <a-select v-model="queryParam.appSsid" mode="multiple">
                <a-select-option v-for="item in appList" :key="item.appssid">
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col> -->

          <a-col :md="9" :sm="8">
            <a-form-item :label="$t(I18N_KEY.REBORROWCOUNT + 'loanCountPlaceholder')">
              <a-input
                :placeholder="$t('enter') + ' ' + $t(I18N_KEY.REBORROWCOUNT + 'loanCountPlaceholder')"
                v-model="queryParam.loanCount"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="3" :sm="8">
            <a-form-item :label="$t(I18N_KEY.REBORROWCOUNT + 'duration')">
              <a-select default-value="" style="width: 120px" v-model="queryParam.duration">
                <a-select-option value="">
                  {{ $t(I18N_KEY.REBORROWCOUNT + 'all') }}
                </a-select-option>
                <a-select-option value="7">
                  {{ $t(I18N_KEY.REBORROWCOUNT + 'days7') }}
                </a-select-option>
                <a-select-option value="10">
                  {{ $t(I18N_KEY.REBORROWCOUNT + 'days10') }}
                </a-select-option>
                <a-select-option value="14">
                  {{ $t(I18N_KEY.REBORROWCOUNT + 'days14') }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{
                $t('reset')
              }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        ref="table"
        :rowKey="
          (record, index) => {
            return index
          }
        "
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        :scroll="{ x: 3400 }"
        bordered
      >
        <template slot="timeStr" slot-scope="text">
          {{ text === 'Total' ? $t(I18N_KEY.REBORROWCOUNT + 'total') : text ? transformTime(text, 1) : '' }}
        </template>
      </a-table>
    </div>
    <v-modal v-model="visible" :title="$t('order.collectionDetail')">
      <div style="padding: 20px">
        <collection-detail
          v-if="visible"
          :orderId="orderId"
          :custInfoId="custInfoId"
          :taskId="taskId"
          :auditDrawer="false"
          @close="visible = false"
        />
      </div>
    </v-modal>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getApplist, reborrowCountInstallment } from '@/webpublicapi/order'
import Dict from '../modules/Dict'
import DictSelect from '../modules/DictSelect'
import exportFile from '@/webpublicapi/exportFile'
import moment from 'moment'
import vModal from '../modules/Modal'
import { transformTime } from '@/components/_util/util'

const I18N_KEY = {
  REBORROWCOUNT: 'reborrowCount.',
}

export default {
  name: 'reborrowCount',
  components: {
    Dict,
    DictSelect,
    vModal,
  },
  data() {
    return {
      I18N_KEY,
      toggleSearchStatus: false,
      visible: false,
      orderId: undefined,
      custInfoId: undefined,
      taskId: undefined,
      // Pagination params
      form: {
        pageNum: 1,
        pageSize: 30,
      },
      total: 0,
      dataSource: [],
      appList: [],
      // Query conditions
      queryParam: {
        lendingTime: [],
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc',
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 },
      },
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t(I18N_KEY.REBORROWCOUNT + 'timeStr'),
          align: 'left',
          dataIndex: 'timeStr',
          scopedSlots: { customRender: 'timeStr' },
        },
        {
          title: this.$t(I18N_KEY.REBORROWCOUNT + 'countSettleOrder'),
          align: 'left',
          dataIndex: 'countSettleOrder',
        },
        {
          title: this.$t(I18N_KEY.REBORROWCOUNT + 'curReborrowCount'),
          align: 'left',
          dataIndex: 'curReborrowCount',
        },
        {
          title: this.$t(I18N_KEY.REBORROWCOUNT + 'reborrowCount2'),
          align: 'left',
          dataIndex: 'reborrowCount2',
        },
        {
          title: this.$t(I18N_KEY.REBORROWCOUNT + 'reborrowCount3'),
          align: 'left',
          dataIndex: 'reborrowCount3',
        },
        {
          title: this.$t(I18N_KEY.REBORROWCOUNT + 'reborrowCount4'),
          align: 'left',
          dataIndex: 'reborrowCount4',
        },
        {
          title: this.$t(I18N_KEY.REBORROWCOUNT + 'reborrowCount5'),
          align: 'left',
          dataIndex: 'reborrowCount5',
        },
        {
          title: this.$t(I18N_KEY.REBORROWCOUNT + 'reborrowCount6'),
          align: 'left',
          dataIndex: 'reborrowCount6',
        },
        {
          title: this.$t(I18N_KEY.REBORROWCOUNT + 'reborrowCount7'),
          align: 'left',
          dataIndex: 'reborrowCount7',
        },
        {
          title: this.$t(I18N_KEY.REBORROWCOUNT + 'reborrowCount8'),
          align: 'left',
          dataIndex: 'reborrowCount8',
        },
        {
          title: this.$t(I18N_KEY.REBORROWCOUNT + 'rate1'),
          align: 'left',
          dataIndex: 'rate1',
        },
        {
          title: this.$t(I18N_KEY.REBORROWCOUNT + 'rate7'),
          align: 'left',
          dataIndex: 'rate7',
        },
        {
          title: this.$t(I18N_KEY.REBORROWCOUNT + 'rate10'),
          align: 'left',
          dataIndex: 'rate10',
        },
        {
          title: this.$t(I18N_KEY.REBORROWCOUNT + 'rate15'),
          align: 'left',
          dataIndex: 'rate15',
        },
        {
          title: this.$t(I18N_KEY.REBORROWCOUNT + 'rate'),
          align: 'left',
          dataIndex: 'rate',
        },
      ]
    },
  },
  created() {
    this.getTime()
    this.getDict()
    this.loadData()
    getApplist().then((res) => {
      this.appList = []
      this.appInList = res.data || []
      for (var i = 0; i < this.appInList.length; i++) {
        if (this.appInList[i].appssid != '') {
          this.appList.push(this.appInList[i])
        }
      }
    })
  },
  methods: {
    getTime() {
      this.queryParam.lendingTime = []
      var nowDate = new Date()
      this.queryParam.lendingTime[0] = moment(nowDate.setDate(nowDate.getDate() - 6))
      this.queryParam.lendingTime[1] = moment(new Date())
    },
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    searchQuery() {
      this.loadData()
    },
    loadData(arg) {
      // Load data If params passed1Then load first page content
      // if (arg === 1) {
      //   this.form.pageNum = 1
      // }
      this.loading = true
      var params = this.getQueryParams() // Query conditions
      reborrowCountInstallment(Object.assign({}, params))
        .then((res) => {
          if (res.code === 1000) {
            // this.total = res.data.total
            this.dataSource = res.data || []
          } else {
            this.total = 0
            this.dataSource = []
            this.$message.error(res.msg)
          }
          this.loading = false
        })
        .catch((e) => {
          this.loading = false
          this.$message.error(e.message)
        })
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    getQueryParams() {
      const { lendingTime } = this.queryParam
      const data = {
        ...this.queryParam,
        settleTimeStart: lendingTime && lendingTime.length ? this.transformTime(lendingTime[0]) : undefined,
        settleTimeEnd: lendingTime && lendingTime.length ? this.transformTime(lendingTime[1]) : undefined,
      }
      delete data.applyDate
      var param = Object.assign({}, data)

      return filterObj(param)
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // Reset dictionary type search box content
    searchReset() {
      var that = this
      this.getTime()
      if (this.queryParam.appSsid) {
        this.queryParam.appSsid = undefined
      }
      this.queryParam.serviceFee = null
      this.queryParam.duration = null
      this.queryParam.orderType = null
      this.queryParam.loanCount = null

      that.loadData(this.form.pageNum)
    },
    changeModal(visible) {
      this.visible = visible
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@/assets/less/common.less';
</style>
